<template>
    <div :class="['cart-product', 'grid-x', {disabled}]">
        <div class="cell">
            <div class="align-middle grid-x product-header">
                <div class="cell auto">
                    <p class="semi-bold color-dark-gray margin-0">{{ product.name }}</p>
                </div>
                <div class="cell shrink remove-action" @click="$emit('remove')">
                    <span class="remove-icon" v-html="Icon.CROSS"></span>
                </div>
            </div>
            <div class="grid-x grid-margin-x">
                <div class="cell auto cart-ingredients">
                    <p class="display-small color-battleship-gray">{{ productContent }}</p>
                </div>
                <div class="cell shrink cart-product-image" v-if="product.image">
                    <picture>
                        <img :alt="product.name + ' Image'" :srcset="`${product.image.card} 1x, ${product.image.card_2x}`">
                    </picture>
                </div>
                <div class="cell">
                    <div class="align-middle grid-x align-justify">
                        <div class="cell shrink quantity">
                            <number-input
                                :value="product.quantity"
                                @change="setQuantity($event.value)"
                                :minimum-amount="1"
                                :disabled="disabled"
                                :allow-positive="!maxProductsReached"
                            ></number-input>
                        </div>
                        <div class="cell shrink">
                            <p class="display-small bold color-dark-gray margin-0" v-if="productPrice">${{ productPrice }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Product from '@/models/product';
import CartModule from '@/stores/modules/cart';
import { getModule } from 'vuex-module-decorators';
import NumberInput from '@/components/common/forms/NumberInput.vue';
import { Icon } from '@/front/icons';

@Component({
    components: { NumberInput }
})
export default class CartProduct extends Vue
{
    @Prop(Object) readonly product!: Product;
    @Prop(Boolean) readonly disabled!: boolean;

    cartModule!: CartModule

    created() {
        this.cartModule = getModule(CartModule, this.$store);
    }

    setQuantity(quantity: number) {
        const product = new Product(this.product);
        product.quantity = quantity;
        this.cartModule.updateProduct(product);
    }

    get maxProductsReached() {
        return this.cartModule.maxProductsReached;
    }

    get productContent() {
        return this.product.getContent();
    }

    get productPrice() {
        if (this.product.price) {
            const productPrice = (this.product.quantity) ? (this.product.price * this.product.quantity) : this.product.price;
            return productPrice.toFixed(2);
        }
        return '';
    }

    get Icon() {
        return Icon;
    }
}
</script>
<style lang="scss">
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';

.cart-product {
    padding: 15px 0;

    .product-header {
        margin-bottom: 5px;
    }

    .cart-product-image {
        padding-top: 4px;
        width: 72px;
        height: 72px;

        @include breakpoint (small only) {
            width: 90px;
            height: 90px;
        }

        @media screen and (max-width: 320px) {
            display: none;
        }

        img {
            object-fit: cover;
            width: 100%;
            height: 100%;
            border-radius: var(--global-radius);
        }
    }

    &.disabled {
        opacity: 0.75;
    }

    .remove-action {
        cursor: pointer;

        .remove-icon {
            width: 30px;
            height: 30px;
            display: block;

            path {
                fill: var(--dark-gray);
            }
        }

    }
}

.cart-ingredients {
    padding: 10px 0 0;
}

</style>
